import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../../app/store/utils/baseQueryWithReauth';
import type { IAdminListResponse } from '../../application/types/admin.types';

export const adminsApi = createApi({
  reducerPath: 'adminsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['CompanyAdmins'],
  endpoints: build => ({
    getCompanyAdmins: build.query<IAdminListResponse, number>({
      query: companyId => ({
        url: `/system/companies/${companyId}/admins/list`,
        method: 'GET',
        params: { limit: 1000 },
      }),
      transformResponse: (response: { data: IAdminListResponse }) => response.data,
      providesTags: (_result, _error, companyId) => [{ type: 'CompanyAdmins', id: companyId }],
    }),
  }),
});

export const { useGetCompanyAdminsQuery } = adminsApi;
